export const outerLoop = [
  10, 338, 297, 332, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379, 378,
  400, 377, 152, 148, 176, 149, 150, 136, 172, 58, 132, 93, 234, 127, 162, 21,
  54, 103, 67, 109,
];

export const linePairs = [
  [164, 393], // Lip 1st loop
  [393, 391],
  [391, 322],
  [322, 410],
  [410, 287],
  [287, 273],
  [273, 335],
  [335, 406],
  [406, 313],
  [313, 18],
  [18, 83],
  [83, 182],
  [182, 106],
  [106, 43],
  [43, 57],
  [57, 186],
  [186, 92],
  [92, 165],
  [165, 167],
  [167, 164],
  [0, 267], // Lip 2nd loop
  [267, 269],
  [269, 270],
  [270, 409],
  [409, 291],
  [291, 375],
  [375, 321],
  [321, 405],
  [405, 314],
  [314, 17],
  [17, 84],
  [84, 181],
  [181, 91],
  [91, 146],
  [146, 61],
  [61, 185],
  [185, 40],
  [40, 39],
  [39, 37],
  [37, 0],
  [76, 184], // Lip 3rd loop
  [184, 74],
  [74, 73],
  [73, 72],
  [72, 11],
  [11, 302],
  [302, 303],
  [303, 304],
  [304, 408],
  [408, 306],
  [306, 307],
  [307, 320],
  [320, 404],
  [404, 315],
  [315, 16],
  [16, 85],
  [85, 180],
  [180, 90],
  [90, 77],
  [77, 76],
  [62, 183], // Lip 3rd loop
  [183, 42],
  [42, 41],
  [41, 38],
  [38, 12],
  [12, 268],
  [268, 271],
  [271, 272],
  [272, 407],
  [407, 291], // 291 is not correct, find the correct point later
  [291, 325],
  [325, 319],
  [319, 403],
  [403, 316],
  [316, 15],
  [15, 86],
  [86, 179],
  [179, 89],
  [89, 96],
  [96, 62],
  [78, 191], // Lip 4th loop
  [191, 80],
  [80, 81],
  [81, 82],
  [82, 13],
  [13, 312],
  [312, 311],
  [311, 310],
  [310, 415],
  [415, 308],
  [308, 324],
  [324, 318],
  [318, 402],
  [402, 317],
  [317, 14],
  [14, 87],
  [87, 178],
  [178, 88],
  [88, 95],
  [95, 78],
  [59, 166], // Left nose inner loop
  [166, 79],
  [79, 239],
  [239, 238],
  [238, 20],
  [20, 60],
  [60, 75],
  [75, 59],
  [59, 166],
  [218, 237], // Left nose outer loop
  [237, 44],
  [44, 241],
  [241, 242],
  [242, 99],
  [99, 240],
  [240, 235],
  [235, 219],
  [219, 218],
  [274, 457], // Right nose outer loop
  [457, 438],
  [438, 439],
  [439, 455],
  [455, 460],
  [460, 328],
  [328, 462],
  [462, 461],
  [461, 274],
  [458, 459], // Right nose inner loop
  [459, 309],
  [309, 392],
  [392, 289],
  [289, 305],
  [305, 290],
  [290, 250],
  [250, 458],
  [10, 338], // Face outer area
  [338, 297],
  [297, 332],
  [332, 284],
  [284, 251],
  [251, 389],
  [389, 356],
  [356, 454],
  [454, 323],
  [323, 361],
  [361, 288],
  [288, 397],
  [397, 365],
  [365, 379],
  [379, 378],
  [378, 400],
  [400, 377],
  [377, 152],
  [152, 148],
  [148, 176],
  [176, 149],
  [149, 150],
  [150, 136],
  [136, 172],
  [172, 58],
  [58, 132],
  [132, 93],
  [93, 234],
  [234, 127],
  [127, 162],
  [162, 21],
  [21, 54],
  [54, 103],
  [103, 67],
  [67, 109],
  [109, 10], // Outer face end here
  [151, 337],
  [337, 299],
  [299, 333],
  [333, 298],
  [298, 301],
  [301, 368],
  [368, 264],
  [264, 447],
  [447, 366],
  [366, 401],
  [401, 435],
  [435, 367],
  [367, 364],
  [364, 394],
  [394, 395],
  [395, 369],
  [369, 396],
  [396, 175],
  [175, 171],
  [171, 140],
  [140, 170],
  [170, 169],
  [169, 135],
  [135, 138],
  [138, 215],
  [215, 177],
  [177, 137],
  [137, 227],
  [227, 34],
  [34, 139],
  [139, 71],
  [71, 68],
  [68, 104],
  [104, 69],
  [69, 108],
  [108, 151],
  [33, 246],
  [246, 161],
  [161, 160],
  [160, 159],
  [159, 158],
  [158, 157],
  [157, 173],
  [173, 133],
  [133, 155],
  [155, 154],
  [154, 153],
  [153, 145],
  [145, 144],
  [144, 163],
  [163, 7],
  [7, 33],
  [130, 247], // Left eye 2nd inner loop
  [247, 30],
  [30, 29],
  [29, 27],
  [27, 28],
  [28, 56],
  [56, 190],
  [190, 243],
  [243, 112],
  [112, 26],
  [26, 22],
  [22, 23],
  [23, 24],
  [24, 110],
  [110, 25],
  [25, 130],
  [113, 225], // Left eye 3rd inner loop
  [225, 224],
  [224, 223],
  [223, 222],
  [222, 221],
  [221, 189],
  [189, 244],
  [244, 233],
  [233, 232],
  [232, 231],
  [231, 230],
  [230, 229],
  [229, 228],
  [228, 31],
  [31, 226],
  [226, 113],
  [124, 46], // Left eye 4th inner loop
  [46, 53],
  [53, 52],
  [52, 65],
  [65, 55],
  [55, 193],
  [193, 245],
  [245, 128],
  [128, 121],
  [121, 120],
  [120, 119],
  [119, 118],
  [118, 117],
  [117, 111],
  [111, 35],
  [35, 124],
  [362, 398], // Right eye
  [398, 384],
  [384, 385],
  [385, 386],
  [386, 387],
  [387, 388],
  [388, 466],
  [466, 263],
  [263, 249],
  [249, 390],
  [390, 373],
  [373, 374],
  [374, 380],
  [380, 381],
  [381, 382],
  [382, 362],
  [463, 414], // Right eye 2nd inner loop
  [414, 286],
  [286, 258],
  [258, 257],
  [257, 259],
  [259, 260],
  [260, 467],
  [467, 359],
  [359, 255],
  [255, 339],
  [339, 254],
  [254, 253],
  [253, 252],
  [252, 256],
  [256, 341],
  [341, 463],
  [464, 413], // Right eye 3rd inner loop
  [413, 441],
  [441, 442],
  [442, 443],
  [443, 444],
  [444, 445],
  [445, 342],
  [342, 446],
  [446, 261],
  [261, 448],
  [448, 449],
  [449, 450],
  [450, 451],
  [451, 452],
  [452, 453],
  [453, 464],
  [465, 417], // Right eye 4th inner loop
  [417, 285],
  [285, 295],
  [295, 282],
  [282, 283],
  [283, 276],
  [276, 353],
  [353, 265],
  [265, 340],
  [340, 346],
  [346, 347],
  [347, 348],
  [348, 349],
  [349, 350],
  [350, 357],
  [357, 465],
  [213, 147], // Face 3rd loop
  [147, 123],
  [123, 116],
  [116, 143],
  [143, 156],
  [156, 70],
  [70, 63],
  [63, 105],
  [105, 66],
  [66, 107],
  [107, 9],
  [9, 336],
  [336, 296],
  [296, 334],
  [334, 293],
  [293, 300],
  [300, 383],
  [383, 372],
  [372, 345],
  [345, 352],
  [352, 376],
  [376, 433],
  [433, 416],
  [416, 434],
  [434, 430],
  [430, 431],
  [431, 262],
  [262, 428],
  [428, 199],
  [199, 208],
  [208, 32],
  [32, 211],
  [211, 210],
  [210, 214],
  [214, 192],
  [192, 213],
  [323, 366], // 1st horizontal line after eye loop
  [366, 352],
  [352, 280],
  [280, 330],
  [330, 329],
  [329, 277],
  [277, 343],
  [343, 399],
  [399, 419],
  [419, 197],
  [197, 196],
  [196, 174],
  [174, 114],
  [114, 47],
  [47, 100],
  [100, 101],
  [101, 50],
  [50, 123],
  [123, 137],
  [137, 93],
  [361, 401], //2nd horizontal line after eye loop
  [401, 376],
  [376, 411],
  [411, 427],
  [427, 436],
  [436, 410],
  [410, 409],
  [409, 408],
  [408, 407],
  [407, 415],
  [288, 435], //3rd horizontal line
  [435, 433],
  [213, 215],
  [215, 58],
  [172, 138], //vertical line 1
  [138, 192],
  [192, 187],
  [187, 50],
  [50, 118],
  [118, 229],
  [229, 24],
  [24, 144],
  [136, 135], // loop line over nose 1
  [135, 214],
  [214, 207],
  [207, 205],
  [205, 36],
  [36, 142],
  [142, 126],
  [126, 217],
  [217, 236],
  [236, 3],
  [3, 195],
  [195, 248],
  [248, 456],
  [456, 437],
  [437, 355],
  [355, 371],
  [371, 266],
  [266, 425],
  [425, 427],
  [427, 434],
  [434, 364],
  [364, 365],
  [397, 367], // vertical line
  [367, 416],
  [416, 411],
  [411, 280],
  [280, 347],
  [347, 449],
  [449, 254],
  [254, 373],
  [379, 394], // vertical line
  [394, 430],
  [430, 422],
  [422, 273],
  [273, 375],
  [375, 307],
  [307, 325],
  [325, 324],
  [378, 395], // vertical line
  [395, 431],
  [431, 424],
  [424, 335],
  [335, 321],
  [321, 320],
  [320, 319],
  [319, 318],
  [400, 369], // vertical line
  [369, 262],
  [262, 418],
  [418, 406],
  [406, 405],
  [405, 404],
  [404, 403],
  [403, 402],
  [377, 396], // vertical line
  [396, 428],
  [428, 421],
  [421, 313],
  [313, 314],
  [314, 315],
  [315, 316],
  [316, 317],
  [152, 175], // vertical line
  [175, 199],
  [199, 200],
  [200, 18],
  [18, 17],
  [17, 16],
  [16, 15],
  [15, 14],
  [148, 171], // vertical line
  [171, 208],
  [208, 201],
  [201, 83],
  [83, 84],
  [84, 85],
  [85, 86],
  [86, 87],
  [176, 140], // vertical line
  [140, 32],
  [32, 194],
  [194, 182],
  [182, 181],
  [181, 180],
  [180, 179],
  [179, 178],
  [149, 170], // vertical line
  [170, 211],
  [211, 204],
  [204, 106],
  [106, 91],
  [91, 90],
  [90, 89],
  [89, 88],
  [150, 169], // vertical line
  [169, 210],
  [210, 202],
  [202, 43],
  [43, 146],
  [146, 77],
  [77, 96],
  [96, 95],
  [132, 177], // horizontal line
  [177, 147],
  [147, 187],
  [187, 207],
  [207, 216],
  [216, 186],
  [186, 185],
  [185, 184],
  [184, 183],
  [183, 191],
  [50, 205], // cheek lip
  [205, 206],
  [206, 92],
  [92, 40],
  [40, 74],
  [74, 42],
  [42, 80],
  [75, 240], // nose-lip
  [240, 98],
  [98, 165],
  [165, 39],
  [39, 73],
  [73, 41],
  [41, 81],
  [60, 99], // nose-lip
  [99, 97],
  [97, 167],
  [167, 37],
  [37, 72],
  [72, 38],
  [38, 82],
  [19, 94], // nose-lip
  [94, 2],
  [2, 164],
  [164, 0],
  [0, 11],
  [11, 12],
  [12, 13],
  [290, 328], // nose-lip
  [328, 326],
  [326, 393],
  [393, 267],
  [267, 302],
  [302, 268],
  [268, 312],
  [305, 460], // nose-lip
  [460, 327],
  [327, 391],
  [391, 269],
  [269, 303],
  [303, 271],
  [271, 311],
  [310, 272], // cheek-lip
  [272, 304],
  [304, 270],
  [270, 322],
  [322, 426],
  [426, 425],
  [425, 280],
  [434, 432], // cheek -lip horizontal
  [432, 287],
  [287, 291],
  [291, 306],
  [214, 212], // cheek -lip horizontal
  [212, 57],
  [57, 61],
  [61, 76],
  [129, 203], // Lip-cheek loop
  [203, 206],
  [206, 216],
  [216, 212],
  [212, 202],
  [202, 204],
  [204, 194],
  [194, 201],
  [201, 200],
  [200, 421],
  [421, 418],
  [418, 424],
  [424, 422],
  [422, 432],
  [432, 436],
  [436, 426],
  [426, 423],
  [423, 358],
  [374, 253], // eye-nose loop
  [253, 450],
  [450, 348],
  [348, 330],
  [330, 266],
  [266, 423],
  [423, 327],
  [327, 326],
  [326, 2],
  [2, 97],
  [97, 98],
  [98, 203],
  [203, 36],
  [36, 101],
  [101, 119],
  [119, 230],
  [230, 23],
  [23, 145],
  [153, 22], // eye-nose loop
  [22, 231],
  [231, 120],
  [120, 100],
  [100, 142],
  [142, 49],
  [49, 115],
  [115, 220],
  [220, 45],
  [45, 4],
  [4, 275],
  [275, 440],
  [440, 344],
  [344, 279],
  [279, 371],
  [371, 329],
  [329, 349],
  [349, 451],
  [451, 252],
  [252, 380],
  [381, 256], // eye-nose loop
  [256, 452],
  [452, 350],
  [350, 277],
  [277, 355],
  [355, 429],
  [429, 360],
  [360, 363],
  [154, 26], // eye-nose loop
  [26, 232],
  [232, 121],
  [121, 47],
  [47, 126],
  [126, 209],
  [209, 131],
  [131, 134],
  [155, 112], // eye-nose loop
  [112, 233],
  [233, 128],
  [128, 114],
  [114, 217],
  [217, 198],
  [198, 134],
  [134, 51],
  [51, 5],
  [5, 281],
  [281, 363],
  [363, 420],
  [420, 437],
  [437, 343],
  [343, 357],
  [357, 453],
  [453, 341],
  [341, 382],
  [122, 188], // nose loop
  [128, 188],
  [188, 174],
  [174, 236],
  [236, 134],
  [134, 220],
  [220, 237],
  [237, 239],
  [351, 412], // nose loop
  [357, 412],
  [412, 399],
  [399, 456],
  [456, 363],
  [363, 440],
  [440, 457],
  [457, 459],
  [133, 243], // eye-nose loop
  [243, 244],
  [244, 245],
  [245, 122],
  [122, 6],
  [6, 351],
  [351, 465],
  [465, 464],
  [464, 463],
  [463, 362],
  [122, 196], // nose line
  [196, 3],
  [3, 51],
  [51, 45],
  [45, 44],
  [351, 419], // nose line
  [419, 248],
  [248, 281],
  [281, 275],
  [275, 274],
  [10, 151], // vertical center nose line
  [151, 9],
  [9, 8],
  [8, 168],
  [168, 6],
  [6, 197],
  [197, 195],
  [195, 5],
  [5, 4],
  [4, 1],
  [44, 1], // nose area fine lines
  [1, 274],
  [1, 125],
  [125, 141],
  [141, 97],
  [1, 354],
  [354, 370],
  [370, 326],
  [241, 125],
  [125, 19],
  [19, 354],
  [354, 461],
  [242, 141],
  [141, 94],
  [94, 370],
  [370, 462],
  [98, 64],
  [64, 129],
  [129, 102],
  [102, 49],
  [102, 48],
  [64, 48],
  [48, 219],
  [219, 166],
  [64, 235],
  [235, 59],
  [48, 115],
  [198, 209],
  [209, 49],
  [131, 115],
  [115, 218],
  [218, 79],
  [279, 331],
  [331, 358],
  [331, 278],
  [278, 439],
  [439, 392],
  [278, 294],
  [358, 294],
  [294, 455],
  [455, 289],
  [429, 279],
  [294, 327],
  [278, 344],
  [344, 438],
  [438, 309],
  [360, 344],
  [429, 420],
  [36, 102],
  [266, 331],
  [173, 190], // nose bridge line
  [190, 189],
  [189, 193],
  [193, 168],
  [168, 417],
  [417, 413],
  [413, 414],
  [414, 398],
  [157, 56], // nose bridge line
  [56, 221],
  [221, 55],
  [55, 8],
  [8, 285],
  [285, 441],
  [441, 286],
  [286, 384],
  [109, 108], // forehead vertical line
  [108, 107],
  [107, 55],
  [338, 337], // forehead vertical line
  [337, 336],
  [336, 285],
  [67, 69], // forehead-eye vertical line
  [69, 66],
  [66, 65],
  [65, 222],
  [222, 28],
  [28, 158],
  [297, 299], // forehead-eye vertical line
  [299, 296],
  [296, 295],
  [295, 442],
  [442, 258],
  [258, 385],
  [332, 333], // forehead-eye vertical line
  [333, 334],
  [334, 282],
  [282, 443],
  [443, 257],
  [257, 386],
  [284, 298], // temple-eye line
  [298, 293],
  [293, 283],
  [283, 444],
  [444, 259],
  [259, 387],
  [251, 301], // temple eye line
  [301, 300],
  [300, 276],
  [276, 445],
  [445, 260],
  [260, 388],
  [389, 368], // temple eye line
  [368, 383],
  [383, 353],
  [353, 342],
  [342, 467],
  [467, 466],
  [356, 264], // temple eye line
  [264, 372],
  [372, 265],
  [265, 446],
  [446, 359],
  [359, 263],
  [454, 447], // temple eye line
  [447, 345],
  [345, 340],
  [340, 261],
  [261, 255],
  [255, 249],
  [323, 366], // temple eye line
  [366, 352],
  [352, 346],
  [346, 448],
  [448, 339],
  [339, 390],
  [103, 104], // temple eye line
  [104, 105],
  [105, 52],
  [52, 223],
  [223, 27],
  [27, 159],
  [54, 68], // temple eye line
  [68, 63],
  [63, 53],
  [53, 224],
  [224, 29],
  [29, 160],
  [21, 71], // temple eye line
  [71, 70],
  [70, 46],
  [46, 225],
  [225, 30],
  [30, 161],
  [162, 139], // temple eye line
  [139, 156],
  [156, 124],
  [124, 113],
  [113, 247],
  [247, 246],
  [127, 34], // temple eye line
  [34, 143],
  [143, 35],
  [35, 226],
  [226, 130],
  [130, 33],
  [234, 227], // temple eye line
  [227, 116],
  [116, 111],
  [111, 31],
  [31, 25],
  [25, 7],
  [93, 137], // temple eye line
  [137, 123],
  [123, 117],
  [117, 228],
  [228, 110],
  [110, 163],
];
